var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { TableBody } from "@mui/material";
import { isEmpty } from "../../../utils";
import Empty from "./Empty";
import TbodyRow from "./TbodyRow";
import TbodyCell from "./TbodyCell";
var Tbody = function (_a) {
    var data = _a.data, columns = _a.columns, loading = _a.loading, emptyText = _a.emptyText, emptyUrl = _a.emptyUrl, onRowClick = _a.onRowClick;
    var EmptyRender = function () {
        if (!data || (data && data.length === 0 && !loading)) {
            return React.createElement(Empty, { colSpan: columns.length, desc: emptyText, src: emptyUrl });
        }
        return null;
    };
    var ColumnsRender = function (_a) {
        var row = _a.row;
        var commonProps = {
            checked: false,
        };
        var columnsRender = columns.map(function (columnItem) {
            if (columnItem.type === "checkbox") {
                var checked_1 = columnItem.checked;
                Object.assign(commonProps, {
                    checked: (function () {
                        var props = {
                            row: row,
                            cell: row[columnItem.id],
                        };
                        if (checked_1 && typeof checked_1 === "function")
                            return checked_1(props);
                    })(),
                });
            }
            return (React.createElement(TbodyCell, __assign({ key: columnItem.id, row: row }, columnItem, commonProps)));
        });
        return React.createElement(React.Fragment, null, columnsRender);
    };
    var RowsRender = function () {
        if (isEmpty(data))
            return null;
        var rows = data.map(function (row, index) { return (React.createElement(TbodyRow, { key: index, index: index, onClick: onRowClick ? function (event) { return onRowClick(row, event); } : undefined },
            React.createElement(ColumnsRender, { row: row }))); });
        return React.createElement(React.Fragment, null, rows);
    };
    return (React.createElement(TableBody, null,
        React.createElement(RowsRender, null),
        React.createElement(EmptyRender, null)));
};
export default Tbody;
